import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";
import cn from "classnames";
import { getStoredFilters } from "@utils/filters";
import { PATIENT_KEY } from "@utils/constants";

const SubtypeSelector = ({
  onChange,
  customStyles,
  className,
}: {
  onChange: Function;
  customStyles: any;
  className: any;
}) => {
  const { t } = useTranslation();
  const storedValue = getStoredFilters(PATIENT_KEY);

  const subtypeOptions = [
    { value: "all", label: t("all") },
    { value: "AML", label: "AML" },
    { value: "AML M0", label: "AML M0" },
    { value: "AML M1", label: "AML M1" },
    { value: "AML M2", label: "AML M2" },
    { value: "AML M3", label: "AML M3" },
    { value: "AML M4", label: "AML M4" },
    { value: "AML M5", label: "AML M5" },
    { value: "AML M6", label: "AML M6" },
    { value: "AML M7", label: "AML M7" },
    { value: "ALL-B", label: "ALL-B" },
    { value: "ALL-T", label: "ALL-T" },
    { value: "Otro", label: "Otro" },
  ];

  return (
    <div className={cn(className)}>
      <ReactSelect
        className={cn("select", "h-[36px] w-[130px] 2xl:w-[170px] py-0")}
        defaultValue={
          storedValue.subtype
            ? { value: storedValue.subtype, label: storedValue.subtype }
            : null
        }
        options={subtypeOptions}
        styles={customStyles}
        placeholder={t("subtype")}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#ED5939",
            primary25: "#F4F4F4",
          },
        })}
        onChange={({ value }: any) => onChange(value)}
      />
    </div>
  );
};

export default SubtypeSelector;
